import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule as NgCommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbAlertModalComponent } from '@app/common/basic/components/nb-alert-modal/nb-alert-modal.component';
import { NbDropdownComponent } from '@app/common/basic/components/nb-dropdown/nb-dropdown.component';
import { NbInputComponent } from '@app/common/basic/components/nb-input/nb-input.component';
import { NbModalBodyComponent } from '@app/common/basic/components/nb-modal-body/nb-modal-body.component';
import { NbModalFooterComponent } from '@app/common/basic/components/nb-modal-footer/nb-modal-footer.component';
import { NbModalHeaderComponent } from '@app/common/basic/components/nb-modal-header/nb-modal-header.component';
import { NbSelectComponent } from '@app/common/basic/components/nb-select/nb-select.component';
import { NbPermissionsDirective } from '@app/common/basic/directives/nb-permissions/nb-permissions.directive';
import { I18nPipe } from '@app/common/basic/pipes/I18nPipe';
import { MixAsyncPipe } from '@app/common/basic/pipes/MixAsyncPipe';
import { AlertService } from '@app/common/basic/services/alert.service';
import { ModalService } from '@app/common/basic/services/modal.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { setTheme } from 'ngx-bootstrap/utils';
import { NbDebounceDirective } from './directives/nb-debounce/nb-debounce.directive';

setTheme('bs4');

/**
 * CommonBasicModule provides basic light-weight components, directives & pipes can be used in other modules
 * Any feature-specified components should be defined in feature module, not in common module
 */
@NgModule({
  imports: [
    // angular common module
    NgCommonModule,
    // angular form module
    FormsModule,
    ReactiveFormsModule,
    // angular drag & drop cdk
    DragDropModule,
    // angular bootstrap modules
    // only import used modules for better bundle size
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
  ],
  exports: [
    // re-export angular common module
    NgCommonModule,
    // re-export angular form module
    FormsModule,
    ReactiveFormsModule,
    // re-export angular drag & drop cdk
    DragDropModule,
    // re-export bootstrap module
    BsDropdownModule,
    ModalModule,
    TabsModule,
    // export components
    NbDropdownComponent,
    NbSelectComponent,
    NbModalHeaderComponent,
    NbModalBodyComponent,
    NbModalFooterComponent,
    NbInputComponent,
    // export pipes
    I18nPipe,
    MixAsyncPipe,
    // export directives
    NbPermissionsDirective,
    NbDebounceDirective,
  ],
  declarations: [
    // declare components
    NbDropdownComponent,
    NbSelectComponent,
    NbModalHeaderComponent,
    NbModalBodyComponent,
    NbModalFooterComponent,
    NbAlertModalComponent,
    NbInputComponent,
    // declare pipes
    I18nPipe,
    MixAsyncPipe,
    // declare directives
    NbPermissionsDirective,
    NbDebounceDirective,
  ],
  providers: [],
})
export class CommonBasicModule {
  static forRoot(): ModuleWithProviders<CommonBasicModule> {
    return {
      ngModule: CommonBasicModule,
      providers: [ModalService, AlertService],
    };
  }
}
